import { configureStore } from '@reduxjs/toolkit';
import storage from 'redux-persist/lib/storage';
import { combineReducers } from 'redux';
import { persistReducer } from 'redux-persist';
import app from 'store/app';
import auth from 'store/auth';
import catalogos from 'store/catalogos';
import { NODE_ENV } from 'utils/env';

const persistConfig = {
  key: 'store',
  storage,
  blacklist: ['catalogos'],
};

const reducers = combineReducers({ app, auth, catalogos });
const persistedReducer = persistReducer(persistConfig, reducers);

// `redux-logger` (antes concatenado aquí en desarrollo) imprime el estado completo
// prev/next en CADA acción -- con un store grande (catálogos, empleados, etc.) y la
// consola abierta, eso bloqueaba el hilo principal más de 2 segundos por acción
// (Chrome lo reportaba como "[Violation] 'message' handler took 2225ms"), suficiente
// para que un clic real (mousedown/mouseup con separación natural) cayera en medio del
// bloqueo y nunca disparara el evento "click" -- necesitando varios intentos para que
// alguno "cupiera" en un hueco libre. Quitado por completo: los DevTools de Redux
// (`devTools: true` abajo) ya cubren la misma necesidad de depuración sin este costo.
const store = configureStore({
  reducer: persistedReducer,
  devTools: NODE_ENV !== 'production',
});

export default store;
